import script from "./AllMediaGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./AllMediaGallery.vue?vue&type=script&setup=true&lang=js"

import "./AllMediaGallery.vue?vue&type=style&index=0&id=32a8a650&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a8a650"]])

export default __exports__